import React from "react";

import { Button, MenuItem, Select, TextField } from "@material-ui/core";
import api from "../../services/api";
import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";
import { Section } from "../../components/ui";
import { getTokens } from "../../styles/tokens";

const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    bar: {
      display: "grid",
      gridTemplateColumns: "repeat(3, minmax(0, 1fr)) auto",
      alignItems: "end",
      gap: 16,
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      },
      [theme.breakpoints.down("xs")]: {
        gridTemplateColumns: "1fr",
      },
    },
    field: {
      display: "flex",
      flexDirection: "column",
      gap: 6,
      minWidth: 0,
    },
    label: {
      fontSize: 12.5,
      fontWeight: 600,
      color: t.textSecondary,
    },
    // a tradução vem em caixa alta ("FILTRAR"); o painel não usa caixa alta em botão
    sentence: {
      display: "inline-block",
      textTransform: "lowercase",
      "&::first-letter": { textTransform: "uppercase" },
    },
  };
});

const Filters = ({
  classes: parentClasses, // mantido por compatibilidade com o Dashboard
  setDateStartTicket,
  setDateEndTicket,
  dateStartTicket,
  dateEndTicket,
  setQueueTicket,
  queueTicket,
  fetchData,
}) => {
  const classes = useStyles();

  const [queues, setQueues] = React.useState(queueTicket || false);
  const [queueOptions, setQueueOptions] = React.useState([]);

  React.useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data } = await api.get("/queue");
        if (active && Array.isArray(data)) setQueueOptions(data);
      } catch (err) {
        // sem lista de filas → só "Todas"
      }
    })();
    return () => {
      active = false;
    };
  }, []);
  const [dateStart, setDateStart] = React.useState(dateStartTicket);
  const [dateEnd, setDateEnd] = React.useState(dateEndTicket);
  const [fetchDataFilter, setFetchDataFilter] = React.useState(false);

  return (
    <Section title={i18n.t("dashboard.filters")}>
      <div className={classes.bar}>
        <div className={classes.field}>
          <label className={classes.label} htmlFor="dashboard-queue-select">
            {i18n.t("dashboard.queueFilter")}
          </label>
          <Select
            id="dashboard-queue-select"
            variant="outlined"
            fullWidth
            value={queues || false}
            onChange={(e) => setQueues(e.target.value)}
          >
            <MenuItem value={false}>{i18n.t("dashboard.allQueues")}</MenuItem>
            {queueOptions.map((queue) => (
              <MenuItem key={queue.id} value={queue.id}>
                {queue.name}
              </MenuItem>
            ))}
          </Select>
        </div>

        <div className={classes.field}>
          <label className={classes.label} htmlFor="dashboard-date-start">
            {i18n.t("dashboard.date.initialDate")}
          </label>
          <TextField
            id="dashboard-date-start"
            fullWidth
            size="small"
            variant="outlined"
            name="dateStart"
            type="date"
            defaultValue={dateStart}
            onChange={(e) => setDateStart(e.target.value)}
          />
        </div>

        <div className={classes.field}>
          <label className={classes.label} htmlFor="dashboard-date-end">
            {i18n.t("dashboard.date.finalDate")}
          </label>
          <TextField
            id="dashboard-date-end"
            fullWidth
            size="small"
            variant="outlined"
            name="dateEnd"
            type="date"
            defaultValue={dateEnd}
            onChange={(e) => setDateEnd(e.target.value)}
          />
        </div>

        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setQueueTicket(queues);
            setDateStartTicket(dateStart);
            setDateEndTicket(dateEnd);
            setFetchDataFilter(!fetchDataFilter);
            fetchData(!fetchDataFilter);
          }}
        >
          <span className={classes.sentence}>{i18n.t("dashboard.filter")}</span>
        </Button>
      </div>
    </Section>
  );
};

export default Filters;
